import React, { useState, useEffect } from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import axios from "axios";
import { baseurl } from "../../../Baseurl";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const Barchart = () => {
  const [chartType, setChartType] = useState("bar");
  const [chartData, setChartData] = useState(null); // Null by default

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseurl}getOrderStatsLast15Days`);
        const data = response.data.data;

        // Extract labels and values
        const labels = data.map((item) =>
          new Date(item.order_date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
          })
        );
        const values = data.map((item) => parseInt(item.total_orders));

        setChartData({
          labels,
          datasets: [
            {
              label: "Orders",
              data: values,
              backgroundColor: "#fa5a7d",
              borderColor: "#fa5a7d",
              borderWidth: 1,
              fill: false,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching order stats:", error);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Orders by Date (Last 15 Days)",
        font: {
          size: 20,
          family: "'Arial', sans-serif",
          weight: "bold",
        },
        color: "#000",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      legend: {
        position: "top",
        labels: {
          font: {
            size: 14,
            family: "'Arial', sans-serif",
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Date",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Orders",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
        grid: {
          borderColor: "rgba(0,0,0,0.1)",
        },
      },
    },
  };

  const toggleChartType = () => {
    setChartType((prev) => (prev === "bar" ? "line" : "bar"));
  };

  return (
    <div>
      <div className="text-end mb-2">
        <button onClick={toggleChartType} className="btn bbg1 text-white">
          Toggle to {chartType === "bar" ? "Line" : "Bar"} Chart
        </button>
      </div>

      <div className="chart-wrapper">
        {chartData ? (
          chartType === "bar" ? (
            <Bar data={chartData} options={options} />
          ) : (
            <Line data={chartData} options={options} />
          )
        ) : (
          <p>Loading chart data...</p>
        )}
      </div>
    </div>
  );
};

export default Barchart;
